import { render } from "./App.vue?vue&type=template&id=e074b386"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e074b386&lang=css"

import exportComponent from "/home/avatar_asi_napoli/avatar.web/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__